"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: "Artboard"
    }), (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M12.76 4.06a2.392 2.392 0 00-2.388 2.393 2.392 2.392 0 002.389 2.394h2.39V6.453a2.392 2.392 0 00-2.39-2.394m0 6.385H6.389A2.392 2.392 0 004 12.837a2.392 2.392 0 002.39 2.395h6.37a2.392 2.392 0 002.39-2.395 2.392 2.392 0 00-2.39-2.393",
        fill: "#36C5F0"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M27.893 12.837a2.392 2.392 0 00-2.389-2.393 2.392 2.392 0 00-2.39 2.393v2.395h2.39a2.392 2.392 0 002.39-2.395m-6.372 0V6.453a2.392 2.392 0 00-2.39-2.394 2.392 2.392 0 00-2.389 2.394v6.384a2.392 2.392 0 002.39 2.395 2.392 2.392 0 002.389-2.395",
        fill: "#2EB67D"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M19.132 28a2.392 2.392 0 002.39-2.394 2.392 2.392 0 00-2.39-2.394h-2.389v2.394A2.392 2.392 0 0019.133 28m0-6.384h6.371a2.392 2.392 0 002.39-2.394 2.392 2.392 0 00-2.39-2.394h-6.372a2.392 2.392 0 00-2.389 2.394 2.392 2.392 0 002.39 2.394",
        fill: "#ECB22E"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M4 19.222a2.392 2.392 0 002.39 2.394 2.392 2.392 0 002.389-2.394v-2.394h-2.39A2.392 2.392 0 004 19.222m6.372 0v6.384A2.392 2.392 0 0012.76 28a2.392 2.392 0 002.39-2.394v-6.384a2.392 2.392 0 00-2.39-2.394 2.392 2.392 0 00-2.39 2.394",
        fill: "#E01E5A"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Slack.js.map